import { RefObject, useEffect, useRef } from 'react';
import { install } from 'resize-observer';

import { DIMENSION_INITIAL_VALUES } from './constants';

const getDimensions = (current: HTMLElement) => current.getBoundingClientRect();

const useElementDimension = (elementRef: RefObject<HTMLElement>) => {
  const dimensionsRef = useRef(DIMENSION_INITIAL_VALUES as DOMRect);

  useEffect(() => {
    if (!elementRef.current) return;

    if (window.ResizeObserver === undefined) {
      install();
    }

    const currentElement = elementRef.current;

    dimensionsRef.current = getDimensions(currentElement);

    const resizeObserver = new ResizeObserver(([entry]) => {
      dimensionsRef.current = getDimensions(entry.target as HTMLElement);
    });
    resizeObserver.observe(currentElement);

    return () => {
      resizeObserver.unobserve(currentElement);
    };
  }, [elementRef]);

  return dimensionsRef.current;
};
export default useElementDimension;
